import { render, staticRenderFns } from "./jizhong.vue?vue&type=template&id=a3f0def4&scoped=true&"
import script from "./jizhong.vue?vue&type=script&lang=js&"
export * from "./jizhong.vue?vue&type=script&lang=js&"
import style0 from "./jizhong.vue?vue&type=style&index=0&id=a3f0def4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f0def4",
  null
  
)

export default component.exports